/**
 * The sanction kinds shown in the sanction stats page.
 * NOTE: they are mutually exclusive - an anticheat ban is not counted as a ban,
 * and an analyse warn is not counted as a warn.
 */
export const sanctionKinds = ['warn', 'analyse', 'jail', 'anticheatJail', 'ban', 'anticheat'] as const;
export type SanctionKind = typeof sanctionKinds[number];

type SanctionCategoryType = {
    label: string;
    shortLabel: string;
    color: string;
};

export const sanctionCategories: Record<SanctionKind, SanctionCategoryType> = {
    warn: {
        label: 'Warns',
        shortLabel: 'Warn',
        color: '#FFB800',
    },
    analyse: {
        label: 'Analyse Warns',
        shortLabel: 'Analyse Warn',
        color: '#22D3EE',
    },
    jail: {
        label: 'Admin Jails',
        shortLabel: 'Jail',
        color: '#FF9C23',
    },
    anticheatJail: {
        label: 'Anticheat Jails',
        shortLabel: 'AC Jail',
        color: '#7C5CFF',
    },
    ban: {
        label: 'Bans',
        shortLabel: 'Ban',
        color: '#FF4848',
    },
    anticheat: {
        label: 'Anticheat Bans',
        shortLabel: 'AC Ban',
        color: '#B03CFF',
    },
};
